import React from 'react';
import { Typography } from 'antd';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { useCanChangeLifeCycle } from '../../services/accessesProvider';
import { modalNames } from '../../../../shared/configs/modal';
import Box from '../../../../shared/ui/Box';
import { Table } from '../../../base/Table';
import LifeCycleWrapper from '../LifeCycleWrapper';

const StepCell = ({ record, column, row }) => {
  const { open } = useModalMethods();

  const {
    stepAddressLifeCycle: { name },
  } = record;

  const canChange = useCanChangeLifeCycle();

  const handleClick = canChange
    ? () => {
        open(modalNames.changeRoomStep, { room: record });
      }
    : undefined;

  const Component = name ? Box : Typography.Text;

  const text = name || 'Не установлено';

  return (
    <Table.BodyCell
      column={column}
      row={row}
      type={!name ? 'default' : undefined}
    >
      <LifeCycleWrapper tooltipTitle={canChange ? 'Изменить этап' : undefined}>
        <Component onClick={handleClick}>{text}</Component>
      </LifeCycleWrapper>
    </Table.BodyCell>
  );
};

export default StepCell;
